module.exports = __webpack_public_path__ + "static/media/Karen.3c68def1.png";